import React, {useState} from 'react'
import {Modal, Icon, Button, ParagraphText} from '@thryvlabs/maverick'
import {useAuthClient} from '../../utils/use-auth-client'
import SkeletonLoader from '../skeleton-loader'

const InvoicePreviewModal = ({invoiceId, invoiceNumber}) => {
  const [invoicePreview, setInvoicePreview] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)
  const client = useAuthClient()

  // (Fixes OOE-UI-E5, OOE-UI-EB, OOE-UI-EC)
  async function getInvoicePdf() {
    setError(null)
    setIsLoading(true)
    try {
      const response = await client(`invoices/pdf/${invoiceId}`)
      setInvoicePreview(URL.createObjectURL(response))
    } catch {
      setError('Could not load this invoice.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Modal
      altBtn={
        <Icon
          type="regular"
          variant="eye"
          style={{cursor: 'pointer'}}
          color="#808080"
        />
      }
      onOpen={getInvoicePdf}
      onClose={() => setIsLoading(true)}
      title={`Invoice #${invoiceNumber}`}
    >
      <div style={{height: '80vh'}}>
        {isLoading ? (
          <SkeletonLoader />
        ) : error ? (
          <div className="d-flex flex-column justify-content-center align-items-center h-100">
            <ParagraphText variant="reg" className="text-center">
              {error}
            </ParagraphText>
            <Button variant="primary" onClick={getInvoicePdf} className="mt-3">
              Retry
            </Button>
          </div>
        ) : (
          <iframe
            title="Invoice Preview"
            src={invoicePreview}
            width="100%"
            height="100%"
          />
        )}
      </div>
    </Modal>
  )
}

export {InvoicePreviewModal}
